module.exports = __webpack_public_path__ + "img/delete.da5cc411.svg";